import React, { Component } from "react";
import BackendLoginService from "../login-components/backendLoginService";
import { Redirect } from "react-router-dom";

export default class Promo extends Component {
  constructor(props) {
    super(props);
  }

  makeCall = (e) => {
    e.preventDefault();

    BackendLoginService.getInstance()
      .authGet("/api/Email/555")
      .then((r) => {
        console.log(r);
        alert(r.data);
        //return r.json();
      })
      .catch((error) => {
        alert(error, "danger");
      });
  };

  render() {
    return (
      <div>
        hello
        <button onClick={this.makeCall}>makeCall</button>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>the Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
